import {ACTION_TYPES} from "../consts";
import {AnalyticsService} from "../../third-party-services/analytics/analytics-service";
import {AnalyticsEventHandler} from "../../infrastructure/handlers/analytics-event-handler";
import {BracketsClickEvent} from "../models/events/brackets.click-event";

export class BracketsClickEventHandler extends AnalyticsEventHandler {
  type = ACTION_TYPES.bracketsClick;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = BracketsClickEvent;
  }
}
